/*
    Esta API genérica se utiliza para realizar peticiones al controlador generico
    de CRUD del api, permitiendo realizar acciones como crear, insertar o guardar y eliminar
    en cualquier tabla de la base de datos que tenga la estructura DBTM y los nombres
    de archivos y carpetas estructurados de manera correcta.

    params must be a FormData object, and it must contain the following fields:
    - dbtm_section: Nombre de la sección o tabla a la que se va a hacer referencia.
    - action: Acción a realizar (GetTable, InsertRow, UpdateRow, DeleteRow, etc.).
    - params: Parámetros adicionales necesarios para la acción específica. Es una instancia de FormData.
*/


import { useState } from 'react';
import LoadingSpinner from 'contexts/loading-spinner/loading-spinner';
import LoadingSpinnerSimple from 'contexts/loading-spinner/loading-spinner-simple';
import { useApiFetcher } from 'utils/fetcher/ApiFetcher';
import useAuth from 'hooks/useAuth';





export const useApiDBTM = () => {
    const ApiFetcher = useApiFetcher();
    const { logout } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("Cargando información");

    

    //-------------------------------------
    const fetchAPI = async ({
        section, 
        action, 
        params, 
        OnLoaded,
        loadingMessage = "Cargando información",
        showSuccessNotificationModal = false,
        showErrorNotificationModal = true
    }) => {

        let formData;

        if(params && params instanceof FormData) {
            console.log("Using provided FormData instance.");
            params.append('dbtm_section', section);
            formData = params; // Use the provided FormData directly
        } else {
            // If params is not a FormData instance, create one
            console.log("Creating new FormData instance.");
            formData = new FormData();
            formData.append('dbtm_section', section);
            
            // Iterate through params and append all values to formData
            if (params) {
                Object.entries(params).forEach(([key, value]) => {
                    console.log("Appending to FormData:", key, value);
                    if (typeof value === 'object' && value !== null && !(value instanceof File) && !(value instanceof Blob)) {
                        // Serialize objects to JSON
                        formData.append(key, JSON.stringify(value));
                    } else {
                        // Append primitive values directly
                        formData.append(key, value);
                    }
                });
            }
        }

        setLoadingText(loadingMessage);
        setIsLoading(true);

        await ApiFetcher({
            type: 'POST',
            url: "?section=dbtm&action="+action,
            data: formData, //formData with serialized objects
            showSuccessNotification: false,
            showErrorNotification: false,
            showSuccessNotificationModal,
            showErrorNotificationModal,
            onSuccess: (payload)=>{
                setIsLoading(false);
                OnLoaded(true, payload);
                return true;
            },
            onError: (responseData)=>{
                console.log("API error:", responseData);
                setIsLoading(false);

                if(responseData === 'LOGOUT') {
                    // Si la respuesta es 'LOGOUT', llamar al logout del contexto de autenticación
                    logout();
                    return false;
                }

                return false;
            },
        });
    }





    //-------------------------------------
    function DeleteItem({
        section, 
        id, 
        softDelete,
        params,
        OnLoaded,
        deleteUserFiles,
        showSuccessNotificationModal = true,
        showErrorNotificationModal = true
    }) {
        console.log("Deleting item from section:", section, "| id:", id, "| softDelete:", softDelete, "| deleteUserFiles:", deleteUserFiles);

        let formData;

        if(params && params instanceof FormData) {
            params.append('dbtm_section', section);
            formData = params; // Use the provided FormData directly
        } else {
            // If params is not a FormData instance, create one
            formData = new FormData();
            formData.append('dbtm_section', section);
            formData.append('id', id);
            formData.append('softDelete', softDelete);
            formData.append('deleteUserFiles', deleteUserFiles);
            
            // Iterate through params and append all values to formData
            if (params) {
                Object.entries(params).forEach(([key, value]) => {
                    console.log("Appending to FormData:", key, value);
                    if (typeof value === 'object' && value !== null && !(value instanceof File) && !(value instanceof Blob)) {
                        // Serialize objects to JSON
                        formData.append(key, JSON.stringify(value));
                    } else {
                        // Append primitive values directly
                        formData.append(key, value);
                    }
                });
            }
        }


        setLoadingText("Eliminando registro de "+section+"...");
        setIsLoading(true);

        return ApiFetcher({
            type: 'POST',
            url: "?section=dbtm&action=DeleteRow",
            data: formData,
            showSuccessNotification: false,
            showErrorNotification: false,
            showSuccessNotificationModal,
            showErrorNotificationModal,
            onSuccess: (payload)=>{
                setIsLoading(false);
                OnLoaded(true, payload);
                return true;
            },
            onError: (responseData)=>{
                console.log("API error", responseData);
                setIsLoading(false);

                if(responseData === 'LOGOUT') {
                    // Si la respuesta es 'LOGOUT', llamar al logout del contexto de autenticación
                    logout();
                    return false;
                }

                return false;
            },
        });
    }




    //-------------------------------------
    /*const GetApiSelectOptions = async (apiTable, labelColumnId , OnLoaded) =>
    {
        const params = new FormData();
        params.append('dbtm_section', apiTable);
        params.append('labelColumnId', labelColumnId);

        return ApiFetcher({
            type: 'POST',
            url: "?section=dbtm&action=GetSelectOptions",
            data: params,
            showSuccessNotification: false,
            showErrorNotification: false,
            showSuccessNotificationModal: false,
            showErrorNotificationModal: true,
            onSuccess: (payload)=>{
                OnLoaded(true, payload.options);
                return true;
            },
            onError: (responseData)=>{
                console.log("API error", responseData);
                return false;
            },
        });
    }*/

    //-------------------------------------
    const GetSelectOptions = async (apiSelectOptionsArray, OnLoaded) => {
        const params = new FormData();
        
        // Convert the ApiSelectOptions array to JSON and append to FormData
        params.append('apiSelectOptions', JSON.stringify(apiSelectOptionsArray));
        params.append('dbtm_section', 'usuarios'); // Used only for controller validation

        return ApiFetcher({
            type: 'POST',
            url: "?section=dbtm&action=GetSelectOptions",
            data: params,
            showSuccessNotification: false,
            showErrorNotification: false,
            showSuccessNotificationModal: false,
            showErrorNotificationModal: true,
            onSuccess: (payload) => {
                // The response might be directly in payload or in payload.options
                const optionsData = payload.options || payload;
                OnLoaded(true, optionsData);
                return true;
            },
            onError: (responseData) => {
                console.log("Batch API Select Options error", responseData);
                OnLoaded(false, {});
                return false;
            },
        });
    }




    //-------------------------------------
    const DynamicAutocompleteSelectOptions = async (apiSelectOption, searchTerm, OnLoaded) => {
        const params = new FormData();
        
        // Create a dynamic autocomplete request with searchTerm
        const dynamicRequest = {
            ...apiSelectOption,
            searchTerm: searchTerm
        };
        
        // Convert the single ApiSelectOption with searchTerm to JSON and append to FormData
        params.append('apiSelectOptions', JSON.stringify(dynamicRequest));
        params.append('dbtm_section', 'usuarios'); // Used only for controller validation

        return ApiFetcher({
            type: 'POST',
            url: "?section=dbtm&action=DynamicAutocompleteSelectOptions",
            data: params,
            showSuccessNotification: false,
            showErrorNotification: false,
            showSuccessNotificationModal: false,
            showErrorNotificationModal: true,
            onSuccess: (payload) => {
                // The API response structure can vary. Let's handle multiple formats:
                // Format 1: { payload: { tableName_columnId: [options] } }
                // Format 2: { tableName_columnId: [options] }
                let optionsData = [];
                
                console.log(`[DynamicAutocomplete] Full API response:`, payload);
                
                if (payload && payload.payload) {
                    // Format 1: Nested in payload object
                    const apiKey = `${apiSelectOption.tableName}_${apiSelectOption.columnId}`;
                    console.log(`[DynamicAutocomplete] Looking for key: ${apiKey} in payload:`, payload.payload);
                    optionsData = payload.payload[apiKey] || [];
                } else if (payload) {
                    // Format 2: Direct response with tableName_columnId key
                    const apiKey = `${apiSelectOption.tableName}_${apiSelectOption.columnId}`;
                    console.log(`[DynamicAutocomplete] Looking for key: ${apiKey} in direct payload:`, payload);
                    
                    if (Array.isArray(payload[apiKey])) {
                        optionsData = payload[apiKey];
                        console.log(`[DynamicAutocomplete] Found options array with ${optionsData.length} items`);
                    } else if (Array.isArray(payload)) {
                        // Format 3: Direct array response
                        optionsData = payload;
                        console.log(`[DynamicAutocomplete] Using direct array response`);
                    } else {
                        // Format 4: Fallback - look for any array property
                        const keys = Object.keys(payload);
                        for (const key of keys) {
                            if (Array.isArray(payload[key])) {
                                optionsData = payload[key];
                                console.log(`[DynamicAutocomplete] Found array at key: ${key}`);
                                break;
                            }
                        }
                    }
                }
                
                console.log(`[DynamicAutocomplete] Final optionsData:`, optionsData);
                console.log(`[DynamicAutocomplete] Is array:`, Array.isArray(optionsData));
                console.log(`[DynamicAutocomplete] Received ${Array.isArray(optionsData) ? optionsData.length : 0} options for ${apiSelectOption.fieldId}`);
                OnLoaded(true, optionsData);
                return true;
            },
            onError: (responseData) => {
                console.log("Dynamic Autocomplete Select Options error", responseData);
                OnLoaded(false, []);
                return false;
            },
        });
    }

    //-------------------------------------
    const LoadingAnimation = () => {
        return (<>
            {isLoading && <LoadingSpinner text={loadingText} bgOpacity={0.0}/>}
        </>);
    }



    //-------------------------------------
    const LoadingAnimationSimple = () => {
        return (<>
            {isLoading && <LoadingSpinnerSimple bgOpacity={0.0}/>}
        </>);
    }

    return {
        fetchAPI,
        DeleteItem,
        //GetApiSelectOptions,
        GetSelectOptions,
        DynamicAutocompleteSelectOptions,
        LoadingAnimation,
        LoadingAnimationSimple,
    }
};
